// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__pgNTl","containerProject":"Projects_containerProject__Z1qAs","titleContainer":"Projects_titleContainer__3JMXQ","myProject":"Projects_myProject__80Zh8"};